module.exports = __webpack_public_path__ + "img/test3.a5bcbcf0.jpg";